<template>
	<div class="fixed inset-y-0 right-0 flex side-over z-50 w-screen md:w-2/5">
		<div class="h-full w-full flex flex-col bg-white shadow-xl">
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-start justify-between">
					<div class="flex items-center gap-2">
						<img
							class="w-6 h-6"
							src="@/assets/images/icons/people-fill.png"
							alt=""
						/>
						<div class="text-2xl font-bold text-neutral-700">
							Thêm {{ $filters.terminology('teacher') }}
						</div>
					</div>
					<div class="ml-3 h-7 flex items-center">
						<button
							class="
								rounded-md
								text-neutral-400
								hover:text-neutral-700
							"
							type="button"
							@click="$emit('close')"
						>
							<span class="sr-only">Close panel</span>
							<svg
								aria-hidden="true"
								class="h-6 w-6"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M6 18L18 6M6 6l12 12"
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
			<div
				class="
					sideover-content
					pt-6
					relative
					flex-1
					px-4
					sm:px-6
					overflow-y-auto
				"
			>
				<div>
					<div>
						<div class="font-semibold text-neutral-600 mb-2">
							Chọn {{ $filters.terminology('teacher') }}*
						</div>
						<div
							class="
								staff
								mb-4
								text-gray-700
								flex
								items-center
								pl-4
							"
							v-for="s in data[0].staff_ids"
							:key="s"
						>
							{{ getStaff(s).name }}
						</div>
						<div
							class="w-full mt-2 mb-4"
							id="input-select"
							v-for="(item, index) in staffSelected"
							:key="index"
						>
							<div
								class="
									bg-white
									select-tabs
									flex
									items-center
									gap-2
								"
							>
								<Multiselect
									v-model="staffSelected[index]"
									:allow-empty="false"
									:options="
										listStaff?.map((s) => {
											return {
												nameSearch: toEnglish(s?.name),
												...s,
											};
										})
									"
									:searchable="true"
									deselect-label="Đã chọn"
									label="nameSearch"
									:placeholder="`Chọn ${$filters.terminology('teacher')}`"
									selectLabel=""
									track-by="id"
								>
									<template #noResult>
										Không tìm thấy kết quả
									</template>
									<template v-slot:option="props">
										<div
											class="
												flex flex-nowrap
												items-center
											"
										>
											<div>
												{{ props.option.name }}
											</div>
										</div>
									</template>
									<template v-slot:singleLabel="{ option }">
										<div
											class="
												flex flex-nowrap
												items-center
												font-medium
											"
										>
											<div>{{ option.name }}</div>
										</div>
									</template>
								</Multiselect>
								<div
									class="
										text-gray-500
										font-semibold
										cursor-pointer
										text-sm
									"
									@click="deleteStaff(index)"
								>
									XOÁ
								</div>
							</div>
						</div>
					</div>
					<div
						class="
							flex
							justify-end
							cursor-pointer
							mt-2
							text-yellow-700
							font-semibold
						"
						@click="createInput"
					>
						Thêm {{ $filters.terminology('teacher') }}
					</div>
					<div class="flex items-center justify-between mt-4">
						<div
							class="
								text-sm
								flex
								items-center
								gap-2
								text-neutral-500
								cursor-pointer
							"
							@click="isAllStaff = !isAllStaff"
						>
							<Checkbox :value="isAllStaff" />
							<span
								>Hiển thị tất cả {{$filters.terminology('teacher_short_name')}} (ngay cả khi bị trùng giờ
								dạy)</span
							>
						</div>
					</div>
					<div>
						<div class="font-semibold text-neutral-600 mt-10">
							Ghi chú*
						</div>
						<div class="w-full mt-2">
							<div class="input-group flex items-center">
								<textarea
									v-model="note"
									placeholder="Ghi chú về sự thay đổi này"
								>
								</textarea>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-6" :id="`list-dropdown-1`">
					<div
						class="
							bg-neutral-50
							flex
							items-center
							justify-between
							p-3
							border
							rounded-t
							cursor-pointer
						"
						@click="openList(1)"
					>
						<div>Số buổi đã chọn</div>
						<div class="relative">
							<div class="pr-10">{{ data.length }} buổi</div>
							<div
								class="
									absolute
									top-1/2
									right-0
									transform
									-translate-y-1/2
									transition-all
									duration-200
								"
								:id="`list-dropdown-1-icon`"
							>
								<svg
									width="12"
									height="6"
									viewBox="0 0 12 6"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M10.5 5.25L6 0.75L1.5 5.25"
										stroke="#48566A"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
							</div>
						</div>
					</div>
					<div
						class="px-4 border border-t-0 rounded-b"
						:id="`list-dropdown-1-content`"
						v-if="data"
					>
						<div
							v-for="(item, index) in data"
							:key="index"
							class="py-4"
						>
							<div
								class="flex items-center justify-between gap-2"
							>
								<div class="text-gray-600 w-1/3">
									<div v-if="item.date">
										{{ $filters.formatDate2(item.date) }}
									</div>
									<div>
										<span>
											{{ item.display_start_slot }}</span
										>
										<span>
											- {{ item.display_end_slot }}</span
										>
									</div>
								</div>
								<div
									class="flex items-center w-1/3"
									v-if="
										item.group_class_id &&
										getClass(item.group_class_id)
									"
								>
									<div
										@click.stop="
											$router.push(
												`/group-classes/${item.group_class_id}`
											)
										"
										class="flex items-center gap-4"
										v-if="
											item.group_class_id &&
											getClass(item.group_class_id)
										"
									>
										<svg
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g
												clip-path="url(#clip0_21795_4077)"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M7.34111 8.43768C7.34111 9.90561 6.15158 11.1204 4.65835 11.1204C3.16511 11.1204 1.97559 9.8803 1.97559 8.41238C1.97559 6.94445 3.16511 5.72961 4.65835 5.72961C6.12627 5.72961 7.34111 6.96976 7.34111 8.43768ZM6.60714 11.3989C7.46765 11.7279 8.1763 12.3606 8.60656 13.1958C7.8979 13.7526 7.3158 14.4866 7.01209 15.3724C6.86023 15.8026 6.73369 16.2835 6.63245 16.7391H0.634203C0.279876 16.7391 -0.0238327 16.4354 0.00147638 16.0557C0.0520945 15.2458 0.229258 14.436 0.507658 13.6767C0.887294 12.6137 1.69718 11.8038 2.70955 11.3989C3.26635 11.7785 3.94969 11.981 4.65834 11.981C5.367 11.981 6.05034 11.7785 6.60714 11.3989ZM23.5136 13.6767C23.134 12.6137 22.3241 11.8038 21.3117 11.3989C20.7296 11.7785 20.0716 11.981 19.3376 11.981C18.6037 11.981 17.9456 11.7785 17.3888 11.3989C16.5283 11.7279 15.8197 12.3606 15.3894 13.1958C16.0981 13.7526 16.6802 14.4866 16.9839 15.3724C17.1357 15.828 17.2623 16.2835 17.3635 16.7391H23.3618C23.7414 16.7391 24.0451 16.4354 23.9945 16.0557C23.9692 15.2458 23.792 14.436 23.5136 13.6767ZM22.0204 8.43768C22.0204 9.90561 20.8309 11.1204 19.3377 11.1204C17.8697 11.1204 16.6549 9.8803 16.6549 8.41238C16.6549 6.94445 17.8444 5.72961 19.3377 5.72961C20.8309 5.72961 22.0204 6.96976 22.0204 8.43768ZM13.9468 13.373C13.39 13.7526 12.7066 13.9551 11.998 13.9551C11.2893 13.9551 10.606 13.7526 10.0492 13.373C9.03682 13.7779 8.20162 14.5878 7.82199 15.6508C7.54359 16.4101 7.39173 17.22 7.31581 18.0299C7.2905 18.4095 7.59421 18.7132 7.97384 18.7132H16.0221C16.4018 18.7132 16.7055 18.4095 16.6802 18.0299C16.6295 17.22 16.4524 16.4101 16.174 15.6508C15.7943 14.5878 14.9591 13.7779 13.9468 13.373ZM14.6808 10.4118C14.6808 11.8798 13.4913 13.0946 11.9981 13.0946C10.5048 13.0946 9.31531 11.9051 9.31531 10.4118C9.31531 8.9439 10.5301 7.72906 11.9981 7.72906C13.466 7.72906 14.6808 8.91859 14.6808 10.4118Z"
													fill="#94A3B8"
												/>
											</g>
											<defs>
												<clipPath id="clip0_21795_4077">
													<rect
														width="24"
														height="24"
														fill="white"
													/>
												</clipPath>
											</defs>
										</svg>
										<div>
											{{
												getClass(item.group_class_id)
													?.name
											}}
										</div>
									</div>
								</div>
								<div>
									<div
										v-if="item.staff_ids"
										class="flex flex-col gap-2"
									>
										<div
											@click.stop="
												$router.push(
													`/record/employee/${staff_id}`
												)
											"
											class="flex items-center"
											v-for="staff_id in item.staff_ids"
											:key="staff_id"
										>
											<div v-if="getStaff(staff_id)">
												<img
													class="
														shadow-sm
														inline-block
														h-9
														w-9
														rounded-full
													"
													:src="
														getStaff(staff_id)
															?.profile_photo
															?.w200
													"
													alt=""
													v-if="
														getStaff(staff_id)
															?.profile_photo
															?.w200
													"
												/>
												<span
													v-else
													class="
														inline-flex
														items-center
														justify-center
														h-9
														w-9
														rounded-full
													"
													:style="{
														background:
															getStaff(staff_id)
																?.profile_photo
																?.default
																?.color,
													}"
												>
													<span
														class="
															font-medium
															leading-none
															text-white text-xs
														"
														>{{
															getStaff(staff_id)
																?.profile_photo
																?.default
																?.initial
														}}</span
													>
												</span>
											</div>
											<div
												v-if="getStaff(staff_id)"
												class="
													ml-4
													text-blue-600
													font-semibold
												"
											>
												{{ getStaff(staff_id).name }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="px-6 py-4 border-t border-yellow-50">
				<div class="flex justify-end">
					<div>
						<button
							:disabled="!note || inProgress"
							class="button-p text-center px-6"
							type="button"
							@click="submit"
						>
							Xác nhận
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import { $api } from '@/services';
import Multiselect from '@suadelabs/vue3-multiselect';
import { toEnglish } from '@/helper/toEnglish';
import Checkbox from '@/components/elements/checkbox/Checkbox.vue';

export default defineComponent({
	name: 'AddStaffFormGroupClass',
	components: { Checkbox, Multiselect },
	props: {
		data: {
			type: Array,
			required: true,
		},

		staffs: {
			type: Object,
			required: true,
		},

		group_classes: {
			type: Object,
			required: true,
		},

		staffOptions: {
			type: Array,
			required: true,
		},
	},

	data() {
		return {
			date: new Date(),
			note: '',
			staffSelected: [''],
			listStaff: [],
			errorNotTeacher: '',
			inProgress: false,
			isAllStaff: false,
		};
	},

	created() {
		this.fetchStaffs();
	},

	watch: {
		staffSelected: {
			handler(value) {
				let arr = value.map((user) => user.id);
				this.listStaff = this.listStaff.filter(
					(item) => !arr.includes(item.id)
				);
			},
			deep: true,
		},

		isAllStaff: {
			handler(value) {
				if (value) this.fetchAllStaffs();
			},
		},
	},

	methods: {
		toEnglish,
		async submit() {
			this.inProgress = true;
			const payload = this.data.map((item) => {
				return item.id
					? { id: item.id }
					: {
							date: item.date,
							group_time_slot_id: item.group_time_slot_id,
					  };
			});
			try {
				await $api.groupClasses.addStaffs({
					ids: payload,
					schedule_session: {
						new_staff_ids: this.staffSelected
							.map((i) => i.id)
							.concat(this.data[0].staff_ids),
						old_staff_ids: this.data[0].staff_ids || '',
						staff_change_note: this.note,
					},
				});
				await this.$store.dispatch('setAlertMessage', {
					message: `Thêm ${this.$filters.terminology('teacher')} thành công`,
				});
				this.$emit('success');
			} catch (e) {
				await this.$store.dispatch('setAlertMessage', {
					message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},

		openList(index) {
			const el = document.getElementById(
				`list-dropdown-${index}-content`
			);
			const icon = document.getElementById(`list-dropdown-${index}-icon`);
			if (el) {
				if (el.classList.contains('hidden')) {
					el.classList.remove('hidden');
					icon?.classList.add('rotate-180');
				} else {
					el.classList.add('hidden');
					icon?.classList.remove('rotate-180');
				}
			}
		},

		getStaff(staff_id) {
			return this.staffs?.[staff_id];
		},

		getClass(class_id) {
			return this.group_classes?.[class_id];
		},

		async fetchStaffs() {
			this.errorNotTeacher = '';
			if (this.isAllStaff) {
				await this.fetchAllStaffs();
				return;
			}
			try {
				const {
					data: { data },
				} = await $api.groupClasses.staffListChangeTask({
					date: this.data[0].date,
					end_slot: this.data[0].end_slot,
					start_slot: this.data[0].start_slot,
					group_class_id: this.data[0]?.group_class_id,
					group_time_slot_id: this.data[0]?.group_time_slot_id,
				});
				if (data.length) {
					this.listStaff = data;
				} else {
					this.errorNotTeacher =
						'Không có giáo viên phù hợp để thay đổi';
				}
			} catch (err) {
				console.log(err);
			}
		},

		async fetchAllStaffs() {
			try {
				const {
					data: { data },
				} = await $api.staff.getActiveEmployees('');
				if (data.length) {
					this.listStaff = data.filter(
						(item) => !this.data[0].staff_ids.includes(item.id)
					);
				} else {
					this.errorNotTeacher =
						'Không có giáo viên phù hợp để thay đổi';
				}
			} catch (err) {
				console.log(err);
			}
		},

		createInput() {
			this.staffSelected.push('');
		},

		deleteStaff(index) {
			this.staffSelected.splice(index, 1);
		},
	},
});
</script>
<style scoped>
.staff {
	background: #f1f5f9;
	border: 0.5px solid #f8fafc;
	box-shadow: 0px 0px 1px 0px #32324733;
	box-shadow: 0px 1px 2px 0px #32324714;
	border-radius: 4px;
	height: 44px;
}
</style>
